import jw_red from "./jw_red.png";
import jw_black from "./jw_black.png";
import jw_double_black from "./jw_double_black.png";
import jw_gold from "./jw_gold.png";
import jw_green from "./jw_green.png";
import jw_platinum from "./jw_platinum.png"; // Check if this is the correct image
import festive from "./festive.png";
import frame from "./frame.png";

function importAll(require) {
  let images = {};

  require.keys().forEach(filePath => {
    const keyName = filePath.replace('./', '').replace('.jpg', '');
    images[keyName] = require(filePath);
  });
  return images;
}

const NewYearPics = importAll(require.context('./ChineseNewYear', false, /\.(png|jpe?g|svg)$/));
const Christmas = importAll(require.context('./Christmas', false, /\.(png|jpe?g|svg)$/));
const General = importAll(require.context('./General', false, /\.(png|jpe?g|svg)$/));
const Love = importAll(require.context('./Love', false, /\.(png|jpe?g|svg)$/));
const FathersDay = importAll(require.context('./FathersDay', false, /\.(png|jpe?g|svg)$/));

const Templates = {
  Previews: importAll(require.context('./Templates/Previews', false, /\.(png|jpe?g|svg)$/)),
  Backgrounds: importAll(require.context('./Templates/Backgrounds', false, /\.(jpg)$/)),
};

export default {
  Templates,
  ChineseNewYear: NewYearPics,
  Christmas,
  FathersDay,
  General,
  Love,
  jw_red,
  jw_black,
  jw_double_black,
  jw_gold,
  jw_green,
  jw_platinum,
  festive,
  frame,
};



// WEBPACK FOOTER //
// ./src/imgs/bottles/backgrounds/index.js